module.exports = __webpack_public_path__ + "static/media/productos_otros_nuez_india.2892de47.jpg";